export enum FrenzyApiModes {
  RawQuery = 'raw-query',
  FilterChange = 'filter-change',
}
